import store, {types as storeTypes} from '../store'
import AlertModule from 'vux/src/plugins/alert/module'


export default function ($http) {
return {
user(from, isMark) {
return $http
.get('/api/wx/user', {
from
})
.then(({data}) => {

if(!data.data || !data.data.user){
return new Promise((resolve) => {
AlertModule.show({
content:'获取授权用户信息失败',
onHide(){
resolve()
}
})
})
}
store.commit(storeTypes.SET_WX_USER, data.data.user);
try{
window.fsSeePath = data.data.fsSeePath;
}catch (ex){
console.log("ex");
}
return data.data.user;
});
},
jsapiParams(url){
return $http
.get(`/api/wx/jsapi/params?url=` + encodeURIComponent(url),{
mask:false
})
.then(({data}) => {
console.log('4444',data.data)
return data.data
}).catch((err)=>{
console.log('errorJsp',err)
})
},
fsUrl(value, thumbnail) {
if (value && value.startsWith("n:")) {
thumbnail = thumbnail || 'm';
let replacement;
if(window.fsSeePath){
replacement = window.fsSeePath+'/$2$3';
if (thumbnail !== 'o') {
replacement = window.fsSeePath+'/$2_' + thumbnail + '$3';
}
}else{
replacement = 'http://fs-$1.360ease.com/$2$3';
if (thumbnail !== 'o') {
replacement = 'http://fs-$1.360ease.com/$2_' + thumbnail + '$3';
}
}
return value.replace(/n:([^\/]+)\/([^\.]+)((\.?).*)/, replacement);
}
return value;
}
}
}



// WEBPACK FOOTER //
// ./src/api/wx.js